import React, { useState, useEffect } from 'react'
import { Dropdown, Form, Button, FormControl, Row, Col, ListGroup, OverlayTrigger } from 'react-bootstrap'
import { CustomToggle } from '../../_reusedcomponents/CustomDropDown'
import '../../../index.css'
import { SizesControl } from './SizesControlView'
import { sizeValues } from './SizesControlView'
import { FetchTransactionInfos, FetchArticleTypeImages } from '../../../fetcher'
import LoadingSpinner from '../../_reusedcomponents/LoadingSpinner'
import AlertMessage from '../../alertmessages/AlertMessageView'
import { DescriptionTooltipView } from '../../_reusedcomponents/DescriptionTooltipView'
import { RenderImage } from '../../images/ImageView'
import { parseFloatCurrency } from '../../../utils/formatting/floatnumberparsing'
import { useHandleAlertMessage } from '../../../utils/togglinghooks'
import { CreateTransactionListView } from './CreateTransactionListView'

let sizeCategory
let articleSysId
let articleIdFaex
let articleNumberDesigner
let salePrice
let image
let articleSizes
let articleDropdown
let colour

/**
 * Container for creating a new transaction
 * Important: Needs to be refactored to use less code redundancy! Especially in lines 65-83 and 119-140
 * @param {any} handleCloseMask handles closing its mask from parent
 * @param {any} reloadParent event for reloading parent container
 * @param {object} [draft] set if container is called with a saved draft to update
 */
const CreateTransactionContainer = ({ handleCloseMask, reloadParent, draft = null }) => {
    const [articles, setArticles] = useState([])
    const [sizeCats, setSizeCats] = useState([])
    const articleHeaderDefault = "Artikeltyp auswählen"
    const [articleNameHeader, setArticleHeader] = useState(articleHeaderDefault)
    const [uiError, setError] = useState(false)
    const { showAlertMessage, openAlert, closeAlert } = useHandleAlertMessage()

    const [showSizes, setShowSizes] = useState([])
    const [articleTypeName, setArticleTypeName] = useState("")

    const [transactionOrder, setTransactionOrder] = useState([])
    const [remark, setRemark] = useState("")

    const [isDraftUpdate, setIsDraftUpdate] = useState(false)
    const [articleDropDownShow, setArticleDropDownShow] = useState(false)
    const [articleDataReady, setArticleDataToReady] = useState(false)

    /**
     * Adds the corresponding images to the fetched articleTypes via SysIds.
     * @param {object[]} articleTypeImages image datas as binary string
     */
    const addingImages = (articleTypeImages) => {
        let copiedArticleData = [...articles]
        articleTypeImages.forEach(image => copiedArticleData.find(x => x.Articles.ArticleTypeSysId == image.ArticleTypeSysId).Articles.Image = 'data:image/png;base64,' + image.Data)
        setArticles(copiedArticleData)
    }

    /**
     * UseEffect hook to fetch transaction infos after rendering
     * If a draft was passed, set transaction datas to the ones already saved in the draft
    */
    useEffect(() => {
        FetchTransactionInfos(setArticles, setSizeCats, openAlert, setArticleDataToReady)

        let newTransactionOrder = [...transactionOrder]
        if (draft !== null) {
            if (newTransactionOrder.find(x => x.sizeCat == sizeCategory) == null)
                newTransactionOrder.push({ sizeCat: sizeCategory, articleTypes: [] })
            if (newTransactionOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId) == null)
                newTransactionOrder.find(x => x.sizeCat == sizeCategory).articleTypes.push({ articleName: articleNameHeader, articleSysId: articleSysId, articleIdFaex: articleIdFaex, articleNumberDesigner: articleNumberDesigner, colour: colour, salePrice: salePrice, image: image, sizeEntries: [] })
            sizeValues.forEach(z =>
            (newTransactionOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.find(x => x.SizeValue == z.size.SizeValue) == null
                ? newTransactionOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.push({ SizeValue: z.size.SizeValue, Amount: parseInt(z.amount), AmountInStorage: parseInt(articleSizes.find(articleSize => articleSize.SizeValue === z.size.SizeValue).AmountInStorage) })
                : newTransactionOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.find(x => x.SizeValue == z.size.SizeValue).Amount += parseInt(z.amount)))
            setTransactionOrder(newTransactionOrder)

            setRemark(draft.Remark)
            setIsDraftUpdate(true)
        }
    }, [])

    /**
     * Fetches images for articleTypes via SysIds if they are already fetched
    */
    useEffect(() => {
        if (articleDataReady) {
            FetchArticleTypeImages(articles.map(x => x.Articles.ArticleTypeSysId.toString()), addingImages, openAlert)
        }
    }, [articleDataReady])

    /**
     * sets UI focus on the dropdown
    */
    const setArticleFocus = () => {
        articleDropdown.focus()
    }

    /**
     * Sets references on article which is going to be added to the transaction
     * @param {any} e default click event
     * @param {object} article article infos needed to identify which article is going to be addad
     */
    const handleChange = (e, article) => {
        if (e !== null) e.preventDefault()
        setArticleHeader(article != null ? article.Articles.Name : articleHeaderDefault)
        setArticleDropDownShow(false)

        if (article != null && article != undefined && article.Articles != undefined) {
            sizeCategory = article.SizeCat
            articleSysId = article.Articles.ArticleTypeSysId
            articleIdFaex = article.Articles.ArticleIdFaex
            articleNumberDesigner = article.Articles.ArticleNumberDesigner
            colour = article.Articles.Colour
            salePrice = article.Articles.SalePrice
            image = article.Articles.Image
            articleSizes = article.Articles.SizeValues

            setArticleTypeName(article.Articles.Name)
            setShowSizes(article.Articles.SizeValues)
        } else {
            sizeCategory = ""
            setArticleTypeName("")
            setShowSizes([])
        }
    }

    /**
     * Submits new transaction data into the transaction. TransactionOrders are sorted after sizecategory for UI purposes.
     * Checks tree-like structure of transactionOrder to identify what is already set in the transaction; updates the rest
     * Resets the list view afterwards
     * @param {any} e default click event
     */
    const submitTransactionOrder = (e) => {
        e.preventDefault()
        if (sizeValues.some(x => parseInt(x.amount) != 0)) {

            let newTransactionOrder = [...transactionOrder]
            if (newTransactionOrder.find(x => x.sizeCat == sizeCategory) == null)
                newTransactionOrder.push({ sizeCat: sizeCategory, articleTypes: [] })
            if (newTransactionOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId) == null)
                newTransactionOrder.find(x => x.sizeCat == sizeCategory).articleTypes.push({ articleName: articleNameHeader, articleSysId: articleSysId, articleIdFaex: articleIdFaex, articleNumberDesigner: articleNumberDesigner, colour: colour, salePrice: salePrice, image: image, sizeEntries: [] })
            sizeValues.forEach(z =>
            (newTransactionOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.find(x => x.SizeValue == z.size.SizeValue) == null
                ? newTransactionOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.push({ SizeValue: z.size.SizeValue, Amount: parseInt(z.amount), AmountInStorage: parseInt(articleSizes.find(articleSize => articleSize.SizeValue === z.size.SizeValue).AmountInStorage) })
                : newTransactionOrder.find(x => x.sizeCat == sizeCategory).articleTypes.find(x => x.articleSysId == articleSysId).sizeEntries.find(x => x.SizeValue == z.size.SizeValue).Amount += parseInt(z.amount)))
            setTransactionOrder(newTransactionOrder)

            handleChange(null, null)
            setArticleTypeName("")
            setShowSizes([])
            setError(false)
        } else {
            setError(true)
        }

        setArticleFocus()
    }

    /**
     * Renders the sizes and input fields.
    */
    const renderOrderInput = () => {
        return (
            <div className="form-inline order-input" id={"sizesControl"}>
                <SizesControl showSizes={showSizes} articleTypeName={articleTypeName} />
                <Button variant="secondary" className="form form-inline order-input order-input-button" type="submit"> ✓ </Button>
            </div>
        )
    }

    /**
     * Renders an error message if neccessary.
    */
    const renderErrorMessage = () => {
        console.log("document.getElementById sizes",  document.getElementById("sizesControl"))

        return (<div className="error error-message">{window.i18n('errorEmptyValue')}</div>)
    }

    /**
     * Removes a specific entry of the transaction order.
     * @param {any} e default click event
     * @param {any} sizeCat sizeCategory of orderEntry to be removed
     * @param {any} articleEntry articleEntry to be removed
     */
    const removeOrderEntry = (e, sizeCat, articleEntry) => {
        e.preventDefault()

        let removeFromTransactionOrder = [...transactionOrder]

        removeFromTransactionOrder.forEach(function (sizeCat) {
            sizeCat.articleTypes = sizeCat.articleTypes.filter(x => x.articleSysId != articleEntry.articleSysId)
        })
        removeFromTransactionOrder = removeFromTransactionOrder.filter(x => x.articleTypes.length > 0)

        setTransactionOrder(removeFromTransactionOrder)
    }

    /**
     * Resets order entries completely.
    */
    const resetOrderEntries = () => {
        setTransactionOrder([])
    }

    /**
     * Sets filter input for article search.
    */
    const [articleFilterInput, setArticleFilterInput] = useState("")
    const handleArticleFilter = (e) => {
        setArticleFilterInput(e.target.value)
    }

    return (
        <div >
            <Form onSubmit={submitTransactionOrder}>

                <Dropdown className="form" >
                    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components-articles" ref={node => articleDropdown = node} onClick={() => setArticleDropDownShow(!articleDropDownShow)}>
                        {articleNameHeader}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="article-dropdown" show={articleDropDownShow} rootCloseEvent=''>

                        <FormControl className="globalSearch-deliveryOrder" as="input" placeholder={window.i18n('articleName') + "..."} value={articleFilterInput} onChange={handleArticleFilter}></FormControl>

                        <div className="dropdown-listGroup">
                            {articles.filter(x => (x.Articles.Name.toLowerCase().includes(articleFilterInput.toLowerCase()) || x.Articles.ArticleNumberDesigner.toLowerCase().includes(articleFilterInput.toLowerCase()) || x.Articles.ArticleIdFaex.toLowerCase().includes(articleFilterInput.toLowerCase())))
                                .sort((a, b) => a.Articles.Name.localeCompare(b.Articles.Name))
                                .map(article =>

                                    <ListGroup.Item className="dropdown-listGroup-item" value={article.Articles.Name} action onClick={(e) => handleChange(e, article)}>
                                        <Row >
                                            <Col className="dropdown-imageColumn">{RenderImage(article.Articles.Image)}</Col>
                                            <Col >{article.Articles.Name}</Col>
                                            <Col className="dropdown-article-smallField">{article.Articles.ArticleIdFaex}</Col>
                                            <Col >{article.Articles.ArticleNumberDesigner}</Col>
                                            <Col >{article.Articles.Colour}</Col>
                                            <Col className="dropdown-article-smallField">{parseFloatCurrency(article.Articles.SalePrice)}</Col>
                                            <OverlayTrigger trigger="hover" placement="top" overlay={DescriptionTooltipView(article.Articles.DescriptionDesigner)}>
                                                <Col className="dropdown-article-description">{article.Articles.DescriptionDesigner}</Col>
                                            </OverlayTrigger>
                                        </Row>
                                    </ListGroup.Item>
                                )
                            }
                        </div>
                        <LoadingSpinner />
                        <Dropdown.Divider />
                    </Dropdown.Menu>
                </Dropdown >

                {articleNameHeader !== articleHeaderDefault ?
                    renderOrderInput() : <div className="placeholder">empty</div>
                }

                {uiError && renderErrorMessage()}

            </Form>

            { <CreateTransactionListView removeOrderEntry={removeOrderEntry} transactionOrder={transactionOrder} articles={articles} remark={remark} resetOrderEntries={resetOrderEntries} handleCloseMask={handleCloseMask} reloadParent={reloadParent} isDraftUpdate={isDraftUpdate} draftSysId={draft !== null ? draft.TransactionSysId : null} />}

            <Form className="remark-form">
                <Form.Group className="mb-3">
                    <Form.Label>{window.i18n('annotationDelivery')}</Form.Label>
                    <Form.Control as="textarea" defaultValue={draft !== null ? draft.Remark : ""} rows={3} onChange={(e) => setRemark(e.target.value)} />
                </Form.Group>
            </Form>

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
        </div>
    )
}

export { CreateTransactionContainer }

